export default {
  dosingEntries: [],
  backupDosingEntries: [],
};
